import { item } from "../fable_modules/fable-library-js.4.28.0/Array.js";
import { tryFind as tryFind_1, ofList } from "../fable_modules/fable-library-js.4.28.0/Map.js";
import { item as item_1, isEmpty, sortBy, length, choose, exists, filter, ofArray, tryFind, indexed, map, collect } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { int32ToString, equals, createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { Gender, GenderModule_toInt, SeatingStyle, SeatingStyleModule_fromInt, TableShapeModule_fromInt } from "../Shared/Types.js";
import { ta, t as t_4 } from "../Lang.js";
import { Detail_noArrangement, Detail_notFound, Detail_noSelection, Detail_emptySeat, Arrange_showScoring, Tooltip_editMode, Detail_edit, Detail_softViolations, Detail_hardViolations, Detail_score, Detail_back, Detail_list, Detail_overview, Common_cancel, Detail_swapHint, Detail_editModeHint, Tooltip_lockFeature, Detail_lockedCount, Detail_changesCount, Detail_done, Detail_rearrangeTitle, Detail_rearrange, Detail_saveComingSoon, Detail_saveAsNew, Detail_reset, Detail_redo, Detail_undo, Detail_seatedGuests, Detail_genderBalance, Detail_gender, Detail_guests, Detail_capacity, Detail_seating, Detail_shape, Detail_tableInfo, Detail_family, Detail_partner, Detail_seat, Detail_table, Detail_name, Detail_guestInfo, Detail_lockTitle, Detail_unlockTitle, Enum_Seating_allsides, Enum_Seating_onesided, Enum_Shape_round, Enum_Shape_square, Enum_Shape_oval, Enum_Shape_rectangular } from "../Shared/Tr.js";
import { bind, defaultArg, map as map_1 } from "../fable_modules/fable-library-js.4.28.0/Option.js";
import { empty as empty_1, FSharpSet__get_Count, FSharpSet__Contains } from "../fable_modules/fable-library-js.4.28.0/Set.js";
import { createElement } from "react";
import { join } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { map as map_2, collect as collect_1, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { max } from "../fable_modules/fable-library-js.4.28.0/Double.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.28.0/Range.js";
import { ArrangementViewMode, EditHistoryModule_canRedo, EditHistoryModule_canUndo } from "../Pages/Event/State.js";
import { helpTooltip } from "./Components.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";

const familyColors = ["family-color-0", "family-color-1", "family-color-2", "family-color-3", "family-color-4", "family-color-5", "family-color-6", "family-color-7", "family-color-8", "family-color-9"];

function familyColorClass(familyIndex) {
    return item(familyIndex % familyColors.length, familyColors);
}

function buildFamilyColorMap(families) {
    return ofList(collect((tupledArg) => map((m) => [m.GuestId, familyColorClass(tupledArg[0])], tupledArg[1][1]), indexed(families)), {
        Compare: comparePrimitives,
    });
}

function findGuest(guests, guestId) {
    return tryFind((g) => (g.Id === guestId), guests);
}

function guestName(guest) {
    return `${guest.FirstName} ${guest.LastName}`;
}

function guestShortName(guest) {
    return `${(guest.FirstName.length > 8) ? (guest.FirstName.slice(undefined, 7 + 1) + ".") : guest.FirstName} ${(guest.LastName.length > 0) ? (guest.LastName[0] + ".") : ""}`;
}

function shapeLabel(shape) {
    const matchValue = TableShapeModule_fromInt(shape);
    switch (matchValue.tag) {
        case 1:
            return t_4(Enum_Shape_rectangular);
        case 2:
            return t_4(Enum_Shape_oval);
        case 3:
            return t_4(Enum_Shape_square);
        default:
            return t_4(Enum_Shape_round);
    }
}

function seatingLabel(style) {
    const matchValue = SeatingStyleModule_fromInt(style);
    if (matchValue.tag === 1) {
        return t_4(Enum_Seating_onesided);
    }
    else {
        return t_4(Enum_Seating_allsides);
    }
}

function seatBox(guest, seatNumber, familyColorMap, selectedGuestId, isEditMode, editSwapFirst, lockedGuestIds, dispatch) {
    let fid, id_1, g_2, sid, g_3, elems;
    const guestId = map_1((g) => g.Id, guest);
    const isLocked = defaultArg(map_1((id) => FSharpSet__Contains(lockedGuestIds, id), guestId), false);
    const isSwapFirst = (guestId != null) && ((editSwapFirst != null) && ((fid = editSwapFirst, (id_1 = guestId, id_1 === fid))));
    const colorClass = (guest == null) ? "" : defaultArg(tryFind_1(guest.Id, familyColorMap), "");
    const isSelected = (guest != null) && ((selectedGuestId != null) && ((g_2 = guest, (sid = selectedGuestId, g_2.Id === sid))));
    return createElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("seat-box"), delay(() => append((colorClass !== "") ? singleton(colorClass) : empty(), delay(() => append((isSelected && !isEditMode) ? singleton("seat-selected") : empty(), delay(() => append((guest == null) ? singleton("seat-empty") : empty(), delay(() => append((isEditMode && isSwapFirst) ? singleton("seat-swap-first") : empty(), delay(() => append((isEditMode && isLocked) ? singleton("seat-locked") : empty(), delay(() => ((((isEditMode && (guest != null)) && !isLocked) && !isSwapFirst) ? singleton("seat-swappable") : empty()))))))))))))))))], ["title", (guest == null) ? (`Seat ${seatNumber} (empty)`) : ((g_3 = guest, (isEditMode && isLocked) ? (`${guestName(g_3)} (locked)`) : ((isEditMode && isSwapFirst) ? (`${guestName(g_3)} (selected for swap)`) : guestName(g_3))))], ["onClick", (e) => {
        e.stopPropagation();
        if (isEditMode) {
            if (guest == null) {
                dispatch(new Msg(199, []));
            }
            else {
                const g_4 = guest;
                if (isLocked) {
                }
                else if (editSwapFirst != null) {
                    if (editSwapFirst === g_4.Id) {
                        dispatch(new Msg(199, []));
                    }
                    else {
                        dispatch(new Msg(198, [g_4.Id]));
                    }
                }
                else {
                    dispatch(new Msg(197, [g_4.Id]));
                }
            }
        }
        else if (guest == null) {
            dispatch(new Msg(191, [undefined]));
        }
        else {
            dispatch(new Msg(191, [guest.Id]));
        }
    }], (elems = toList(delay(() => append(singleton(createElement("span", {
        className: "seat-label",
        children: (guest == null) ? "-" : guestShortName(guest),
    })), delay(() => ((isEditMode && (guest != null)) ? singleton(createElement("button", {
        className: isLocked ? "seat-lock-btn seat-lock-active" : "seat-lock-btn",
        title: isLocked ? t_4(Detail_unlockTitle) : t_4(Detail_lockTitle),
        onClick: (e_1) => {
            e_1.stopPropagation();
            if (guest == null) {
            }
            else {
                dispatch(new Msg(200, [guest.Id]));
            }
        },
        children: isLocked ? "L" : "U",
    })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function roundTable(table, tableIndex, assignments, guests, familyColorMap, selectedGuestId, selectedTableIndex, isEditMode, editSwapFirst, lockedGuestIds, dispatch) {
    let elems_2, elems_1;
    const isSelectedTable = (selectedTableIndex == null) ? false : (selectedTableIndex === tableIndex);
    const className = join(" ", toList(delay(() => append(singleton("table-visual table-round"), delay(() => (isSelectedTable ? singleton("table-visual-selected") : empty()))))));
    const sizePx = max(140, ~~((max(4, table.Capacity) * 60) / 3.141592653589793)) | 0;
    return createElement("div", createObj(ofArray([["className", className], ["style", {
        width: sizePx + "px",
        height: sizePx + "px",
    }], ["onClick", (_arg) => {
        if (!isEditMode) {
            dispatch(new Msg(192, [tableIndex]));
        }
    }], (elems_2 = [createElement("div", {
        className: "table-center-label",
        children: table.Name,
    }), createElement("div", createObj(ofArray([["className", "round-seats"], (elems_1 = toList(delay(() => collect_1((seatNum) => {
        let elems;
        const guest = bind((a_1) => findGuest(guests, a_1.GuestId), tryFind((a) => (a.SeatNumber === seatNum), assignments));
        const angle = ((360 / table.Capacity) * (seatNum - 1)) - 90;
        return singleton(createElement("div", createObj(ofArray([["className", "round-seat-wrapper"], ["style", {
            left: (50 + (42 * Math.cos((angle * 3.141592653589793) / 180))) + "%",
            top: (50 + (42 * Math.sin((angle * 3.141592653589793) / 180))) + "%",
        }], (elems = [seatBox(guest, seatNum, familyColorMap, selectedGuestId, isEditMode, editSwapFirst, lockedGuestIds, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    }, rangeDouble(1, 1, table.Capacity)))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function rectangularTable(table, tableIndex, assignments, guests, familyColorMap, selectedGuestId, selectedTableIndex, isEditMode, editSwapFirst, lockedGuestIds, dispatch) {
    let elems_5, elems_3;
    const isSelectedTable = (selectedTableIndex == null) ? false : (selectedTableIndex === tableIndex);
    const className = join(" ", toList(delay(() => append(singleton("table-visual table-rect"), delay(() => (isSelectedTable ? singleton("table-visual-selected") : empty()))))));
    const L = table.SeatsLongSide | 0;
    const H = table.SeatsShortEnd | 0;
    const leftCount = ((H > 0) ? H : 0) | 0;
    const rightCount = ((H > 0) ? H : 0) | 0;
    let seatIdx = 1;
    const nextSeats = (count) => toList(delay(() => collect_1((matchValue) => {
        let seatNum;
        return append(singleton((seatNum = (seatIdx | 0), seatBox(bind((a_1) => findGuest(guests, a_1.GuestId), tryFind((a) => (a.SeatNumber === seatNum), assignments)), seatNum, familyColorMap, selectedGuestId, isEditMode, editSwapFirst, lockedGuestIds, dispatch))), delay(() => {
            seatIdx = ((seatIdx + 1) | 0);
            return empty();
        }));
    }, rangeDouble(1, 1, count))));
    const topSeats = nextSeats(L);
    const rightSeats = nextSeats(rightCount);
    const bottomSeats = nextSeats(L);
    const leftSeats = nextSeats(leftCount);
    return createElement("div", createObj(ofArray([["className", className], ["style", {
        width: ((max(2, L) * 60) + 80) + "px",
    }], ["onClick", (_arg) => {
        if (!isEditMode) {
            dispatch(new Msg(192, [tableIndex]));
        }
    }], (elems_5 = [createElement("div", {
        className: "rect-side rect-top",
        children: reactApi.Children.toArray(Array.from(topSeats)),
    }), createElement("div", createObj(ofArray([["className", "rect-middle"], (elems_3 = [createElement("div", {
        className: "rect-side rect-left",
        children: reactApi.Children.toArray(Array.from(leftSeats)),
    }), createElement("div", {
        className: "table-center-label",
        children: table.Name,
    }), createElement("div", {
        className: "rect-side rect-right",
        children: reactApi.Children.toArray(Array.from(rightSeats)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", {
        className: "rect-side rect-bottom",
        children: reactApi.Children.toArray(Array.from(bottomSeats)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function oneSidedTable(table, tableIndex, assignments, guests, familyColorMap, selectedGuestId, selectedTableIndex, isEditMode, editSwapFirst, lockedGuestIds, dispatch) {
    let elems_1, elems;
    const isSelectedTable = (selectedTableIndex == null) ? false : (selectedTableIndex === tableIndex);
    return createElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("table-visual table-onesided"), delay(() => (isSelectedTable ? singleton("table-visual-selected") : empty()))))))], ["onClick", (_arg) => {
        if (!isEditMode) {
            dispatch(new Msg(192, [tableIndex]));
        }
    }], (elems_1 = [createElement("div", {
        className: "table-center-label mb-1",
        children: table.Name,
    }), createElement("div", createObj(ofArray([["className", "onesided-seats"], (elems = toList(delay(() => collect_1((seatNum) => singleton(seatBox(bind((a_1) => findGuest(guests, a_1.GuestId), tryFind((a) => (a.SeatNumber === seatNum), assignments)), seatNum, familyColorMap, selectedGuestId, isEditMode, editSwapFirst, lockedGuestIds, dispatch)), rangeDouble(1, 1, table.Capacity)))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function renderTable(table, tableIndex, assignments, guests, familyColorMap, selectedGuestId, selectedTableIndex, isEditMode, editSwapFirst, lockedGuestIds, dispatch) {
    const tableAssignments = filter((a) => (a.TableId === table.Id), assignments);
    if (equals(SeatingStyleModule_fromInt(table.SeatingStyle), new SeatingStyle(1, []))) {
        return oneSidedTable(table, tableIndex, tableAssignments, guests, familyColorMap, selectedGuestId, selectedTableIndex, isEditMode, editSwapFirst, lockedGuestIds, dispatch);
    }
    else {
        const matchValue = TableShapeModule_fromInt(table.Shape);
        switch (matchValue.tag) {
            case 1:
            case 3:
                return rectangularTable(table, tableIndex, tableAssignments, guests, familyColorMap, selectedGuestId, selectedTableIndex, isEditMode, editSwapFirst, lockedGuestIds, dispatch);
            default:
                return roundTable(table, tableIndex, tableAssignments, guests, familyColorMap, selectedGuestId, selectedTableIndex, isEditMode, editSwapFirst, lockedGuestIds, dispatch);
        }
    }
}

function guestInfoPanel(guest, assignments, tables, pairs, guests, families) {
    let elems_1, elems, children_10, children, children_2, children_4, children_6, children_8;
    const assignment = tryFind((a) => (a.GuestId === guest.Id), assignments);
    let tableName;
    if (assignment == null) {
        tableName = "Unassigned";
    }
    else {
        const a_1 = assignment;
        tableName = defaultArg(map_1((t_1) => t_1.Name, tryFind((t) => (t.Id === a_1.TableId), tables)), "?");
    }
    const seatNum = (assignment == null) ? "-" : int32ToString(assignment.SeatNumber);
    let partnerInfo;
    const partnerPair = tryFind((p) => {
        if (p.Guest1Id === guest.Id) {
            return true;
        }
        else {
            return p.Guest2Id === guest.Id;
        }
    }, pairs);
    if (partnerPair == null) {
        partnerInfo = "None";
    }
    else {
        const p_1 = partnerPair;
        const partner = findGuest(guests, (p_1.Guest1Id === guest.Id) ? p_1.Guest2Id : p_1.Guest1Id);
        if (partner == null) {
            partnerInfo = "-";
        }
        else {
            const pg = partner;
            const partnerTable = defaultArg(map_1((t_3) => t_3.Name, bind((a_4) => tryFind((t_2) => (t_2.Id === a_4.TableId), tables), tryFind((a_3) => (a_3.GuestId === pg.Id), assignments))), "?");
            partnerInfo = (`${guestName(pg)} (${partnerTable})`);
        }
    }
    const familyName = defaultArg(map_1((tupledArg_1) => tupledArg_1[0].Name, tryFind((tupledArg) => exists((m) => (m.GuestId === guest.Id), tupledArg[1]), families)), "None");
    return createElement("div", createObj(ofArray([["className", "card detail-info-panel"], (elems_1 = [createElement("h4", {
        className: "mb-1",
        children: t_4(Detail_guestInfo),
    }), createElement("table", createObj(ofArray([["className", "detail-info-table"], (elems = [(children_10 = ofArray([(children = ofArray([createElement("td", {
        children: t_4(Detail_name),
    }), createElement("td", {
        children: guestName(guest),
    })]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = ofArray([createElement("td", {
        children: t_4(Detail_table),
    }), createElement("td", {
        children: tableName,
    })]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    })), (children_4 = ofArray([createElement("td", {
        children: t_4(Detail_seat),
    }), createElement("td", {
        children: seatNum,
    })]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children_4)),
    })), (children_6 = ofArray([createElement("td", {
        children: t_4(Detail_partner),
    }), createElement("td", {
        children: partnerInfo,
    })]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children_6)),
    })), (children_8 = ofArray([createElement("td", {
        children: t_4(Detail_family),
    }), createElement("td", {
        children: familyName,
    })]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children_8)),
    }))]), createElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children_10)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function tableInfoPanel(table, assignments, guests) {
    let elems_3;
    const tableGuests = choose((a_1) => findGuest(guests, a_1.GuestId), filter((a) => (a.TableId === table.Id), assignments));
    const maleCount = length(filter((g) => (g.Gender === GenderModule_toInt(new Gender(0, []))), tableGuests)) | 0;
    const femaleCount = length(filter((g_1) => (g_1.Gender === GenderModule_toInt(new Gender(1, []))), tableGuests)) | 0;
    return createElement("div", createObj(ofArray([["className", "card detail-info-panel"], (elems_3 = toList(delay(() => append(singleton(createElement("h4", {
        className: "mb-1",
        children: t_4(Detail_tableInfo),
    })), delay(() => {
        let elems, children_12, children, children_2, children_4, children_6, children_8, children_10, tupledArg;
        return append(singleton(createElement("table", createObj(ofArray([["className", "detail-info-table"], (elems = [(children_12 = ofArray([(children = ofArray([createElement("td", {
            children: t_4(Detail_name),
        }), createElement("td", {
            children: table.Name,
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children)),
        })), (children_2 = ofArray([createElement("td", {
            children: t_4(Detail_shape),
        }), createElement("td", {
            children: shapeLabel(table.Shape),
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        })), (children_4 = ofArray([createElement("td", {
            children: t_4(Detail_seating),
        }), createElement("td", {
            children: seatingLabel(table.SeatingStyle),
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_4)),
        })), (children_6 = ofArray([createElement("td", {
            children: t_4(Detail_capacity),
        }), createElement("td", {
            children: int32ToString(table.Capacity),
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_6)),
        })), (children_8 = ofArray([createElement("td", {
            children: t_4(Detail_guests),
        }), createElement("td", {
            children: int32ToString(length(tableGuests)),
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_8)),
        })), (children_10 = ofArray([createElement("td", {
            children: t_4(Detail_gender),
        }), createElement("td", {
            children: (tupledArg = Detail_genderBalance(int32ToString(maleCount), int32ToString(femaleCount)), ta(tupledArg[0], tupledArg[1])),
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_10)),
        }))]), createElement("tbody", {
            children: reactApi.Children.toArray(Array.from(children_12)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2, elems_1;
            return (length(tableGuests) > 0) ? singleton(createElement("div", createObj(ofArray([["className", "mt-1"], (elems_2 = [createElement("strong", {
                children: t_4(Detail_seatedGuests),
            }), createElement("ul", createObj(ofArray([["className", "detail-guest-list"], (elems_1 = toList(delay(() => map_2((g_2) => createElement("li", {
                children: guestName(g_2),
            }), tableGuests))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty();
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function findArrangement(arrangements, arrangementId) {
    return tryFind((s) => (s.Id === arrangementId), arrangements);
}

function editToolbar(state, dispatch) {
    let elems_3, elems, elems_2;
    const changeCount = length(state.EditHistory.Past) | 0;
    const canUndo = EditHistoryModule_canUndo(state.EditHistory);
    const canRedo = EditHistoryModule_canRedo(state.EditHistory);
    const lockedCount = FSharpSet__get_Count(state.LockedGuestIds) | 0;
    return createElement("div", createObj(ofArray([["className", "edit-toolbar"], (elems_3 = [createElement("div", createObj(ofArray([["className", "edit-toolbar-buttons"], (elems = [createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t_4(Detail_undo),
        disabled: !canUndo,
        onClick: (_arg) => {
            dispatch(new Msg(203, []));
        },
    }), createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t_4(Detail_redo),
        disabled: !canRedo,
        onClick: (_arg_1) => {
            dispatch(new Msg(204, []));
        },
    }), createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t_4(Detail_reset),
        disabled: changeCount < 1,
        onClick: (_arg_2) => {
            dispatch(new Msg(205, []));
        },
    }), createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t_4(Detail_saveAsNew),
        disabled: true,
        title: t_4(Detail_saveComingSoon),
    }), createElement("button", {
        className: "btn btn-sm btn-primary",
        children: t_4(Detail_rearrange),
        disabled: lockedCount < 1,
        title: t_4(Detail_rearrangeTitle),
        onClick: (_arg_3) => {
            dispatch(new Msg(206, []));
        },
    }), createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t_4(Detail_done),
        onClick: (_arg_4) => {
            dispatch(new Msg(196, []));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "edit-toolbar-status"], (elems_2 = toList(delay(() => {
        let tupledArg;
        return append(singleton(createElement("span", {
            className: "text-sm",
            children: (tupledArg = Detail_changesCount(int32ToString(changeCount)), ta(tupledArg[0], tupledArg[1])),
        })), delay(() => {
            let elems_1, tupledArg_1;
            return (lockedCount > 0) ? singleton(createElement("span", createObj(ofArray([["className", "text-sm text-muted"], (elems_1 = [(tupledArg_1 = Detail_lockedCount(int32ToString(lockedCount)), ta(tupledArg_1[0], tupledArg_1[1])), helpTooltip(t_4(Tooltip_lockFeature))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function editStatusBar(state) {
    let elems;
    let hintText;
    const matchValue = state.EditSwapFirst;
    if (matchValue == null) {
        hintText = t_4(Detail_editModeHint);
    }
    else {
        const firstId = matchValue;
        const tupledArg = Detail_swapHint(defaultArg(map_1((g_1) => (`${g_1.FirstName} ${g_1.LastName}`), tryFind((g) => (g.Id === firstId), state.Guests)), "?"));
        hintText = ta(tupledArg[0], tupledArg[1]);
    }
    return createElement("div", createObj(ofArray([["className", "edit-status-bar"], (elems = toList(delay(() => append(singleton(createElement("span", {
        className: "text-sm",
        children: hintText,
    })), delay(() => ((state.EditSwapFirst != null) ? singleton(createElement("button", {
        className: "btn-link text-sm",
        children: t_4(Common_cancel),
        onClick: (_arg) => {
        },
    })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function viewModeToggle(currentMode, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "arrangement-view-toggle"], (elems = [createElement("button", {
        className: (currentMode.tag === 1) ? "btn btn-sm btn-secondary" : "btn btn-sm btn-primary",
        children: t_4(Detail_overview),
        onClick: (_arg) => {
            dispatch(new Msg(194, [new ArrangementViewMode(0, [])]));
        },
    }), createElement("button", {
        className: (currentMode.tag === 0) ? "btn btn-sm btn-secondary" : "btn btn-sm btn-primary",
        children: t_4(Detail_list),
        onClick: (_arg_1) => {
            dispatch(new Msg(194, [new ArrangementViewMode(1, [])]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function arrangementHeader(arrangement, isEditMode, viewMode, dispatch) {
    let elems_4;
    const scorePercent = ~~arrangement.Score | 0;
    return createElement("div", createObj(ofArray([["className", "arrangement-detail-header"], (elems_4 = toList(delay(() => append(singleton(createElement("button", {
        className: "btn btn-sm btn-secondary",
        children: t_4(Detail_back),
        disabled: isEditMode,
        onClick: (_arg) => {
            if (!isEditMode) {
                dispatch(new Msg(190, []));
            }
        },
    })), delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "arrangement-detail-stats"], (elems = [createElement("span", {
            className: "text-sm",
            children: `${t_4(Detail_score)}: ${scorePercent}/100`,
        }), createElement("span", {
            className: "text-sm",
            children: `${t_4(Detail_hardViolations)}: ${arrangement.HardViolations}`,
        }), createElement("span", {
            className: "text-sm",
            children: `${t_4(Detail_softViolations)}: ${arrangement.SoftViolations}`,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(!isEditMode ? append(singleton(viewModeToggle(viewMode, dispatch)), delay(() => {
            let elems_1;
            return singleton(createElement("span", createObj(ofArray([["className", "flex items-center gap-sm"], (elems_1 = [createElement("button", {
                className: "btn btn-sm btn-primary",
                children: t_4(Detail_edit),
                onClick: (_arg_1) => {
                    dispatch(new Msg(195, []));
                },
            }), helpTooltip(t_4(Tooltip_editMode))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        })) : empty(), delay(() => {
            let elems_3, tupledArg, elems_2;
            return (length(arrangement.SoftPenaltyDetails) > 0) ? singleton(createElement("details", createObj(ofArray([["className", "arrangement-penalty-details"], (elems_3 = [createElement("summary", {
                className: "text-sm text-muted",
                children: (tupledArg = Arrange_showScoring(int32ToString(length(arrangement.SoftPenaltyDetails))), ta(tupledArg[0], tupledArg[1])),
            }), createElement("ul", createObj(ofArray([["className", "penalty-detail-list"], (elems_2 = map((detail) => createElement("li", {
                className: "text-sm",
                children: detail,
            }), arrangement.SoftPenaltyDetails), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty();
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function listViewTable(table, assignments, guests) {
    let elems_2, elems, elems_1;
    const tableGuests = choose((a_2) => findGuest(guests, a_2.GuestId), sortBy((a_1) => a_1.SeatNumber, filter((a) => (a.TableId === table.Id), assignments), {
        Compare: comparePrimitives,
    }));
    const emptySeats = (table.Capacity - length(tableGuests)) | 0;
    return createElement("div", createObj(ofArray([["className", "list-view-table"], (elems_2 = [createElement("div", createObj(ofArray([["className", "list-view-table-header"], (elems = [createElement("strong", {
        children: table.Name,
    }), createElement("span", {
        className: "text-muted text-sm",
        children: `(${length(tableGuests)}/${table.Capacity})`,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("ul", createObj(ofArray([["className", "list-view-guest-list"], (elems_1 = toList(delay(() => append(map_2((g) => createElement("li", {
        className: "list-view-guest-item",
        children: guestName(g),
    }), tableGuests), delay(() => collect_1((matchValue) => singleton(createElement("li", {
        className: "list-view-guest-item list-view-empty-seat",
        children: t_4(Detail_emptySeat),
    })), rangeDouble(1, 1, emptySeats)))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function listView(state) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "arrangement-list-view"], (elems = toList(delay(() => map_2((table) => listViewTable(table, state.ArrangementAssignments, state.Guests), state.Tables))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

/**
 * Read-only visual preview of tables, showing guests if assignments exist.
 * Used on the Tables tab to show table shapes and layout.
 */
export function tablesOnlyPreview(state, dispatch) {
    let elems;
    if (isEmpty(state.Tables)) {
        return defaultOf();
    }
    else {
        const familyColorMap = buildFamilyColorMap(state.Families);
        return createElement("div", createObj(ofArray([["className", "arrangement-tables-area"], (elems = toList(delay(() => collect_1((matchValue) => singleton(renderTable(matchValue[1], matchValue[0], state.ArrangementAssignments, state.Guests, familyColorMap, undefined, undefined, false, undefined, empty_1({
            Compare: comparePrimitives,
        }), dispatch)), indexed(state.Tables)))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

/**
 * Read-only table preview for inline display below the arrangement card grid.
 * Respects the current ArrangementViewMode toggle.
 */
export function tablePreview(state, dispatch) {
    let elems;
    if (state.ArrangementViewMode.tag === 0) {
        const familyColorMap = buildFamilyColorMap(state.Families);
        return createElement("div", createObj(ofArray([["className", "arrangement-tables-area"], (elems = toList(delay(() => collect_1((matchValue_1) => singleton(renderTable(matchValue_1[1], matchValue_1[0], state.ArrangementAssignments, state.Guests, familyColorMap, undefined, undefined, false, undefined, empty_1({
            Compare: comparePrimitives,
        }), dispatch)), indexed(state.Tables)))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return listView(state);
    }
}

export function view(state, dispatch) {
    let elems_3;
    const matchValue = state.SelectedArrangementId;
    if (matchValue != null) {
        const arrangement = findArrangement(state.Arrangements, matchValue);
        const familyColorMap = buildFamilyColorMap(state.Families);
        if (arrangement != null) {
            const arr = arrangement;
            return createElement("div", createObj(ofArray([["className", state.IsEditMode ? "arrangement-detail arrangement-edit-mode" : "arrangement-detail"], (elems_3 = toList(delay(() => append(singleton(arrangementHeader(arr, state.IsEditMode, state.ArrangementViewMode, dispatch)), delay(() => append(state.IsEditMode ? append(singleton(editToolbar(state, dispatch)), delay(() => singleton(editStatusBar(state)))) : empty(), delay(() => {
                let elems_2;
                return (state.ArrangementViewMode.tag === 0) ? singleton(createElement("div", createObj(ofArray([["className", "arrangement-detail-layout"], (elems_2 = toList(delay(() => {
                    let elems;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "arrangement-tables-area"], ["onClick", (_arg) => {
                        if (state.IsEditMode && (state.EditSwapFirst != null)) {
                            dispatch(new Msg(199, []));
                        }
                    }], (elems = toList(delay(() => collect_1((matchValue_2) => singleton(renderTable(matchValue_2[1], matchValue_2[0], state.ArrangementAssignments, state.Guests, familyColorMap, state.SelectedDetailGuestId, state.SelectedDetailTableIndex, state.IsEditMode, state.EditSwapFirst, state.LockedGuestIds, dispatch)), indexed(state.Tables)))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                        let elems_1;
                        return !state.IsEditMode ? singleton(createElement("div", createObj(ofArray([["className", "arrangement-detail-sidebar"], (elems_1 = toList(delay(() => {
                            const matchValue_3 = state.SelectedDetailGuestId;
                            if (matchValue_3 == null) {
                                const matchValue_5 = state.SelectedDetailTableIndex;
                                let matchResult, tidx_1;
                                if (matchValue_5 != null) {
                                    if (matchValue_5 < length(state.Tables)) {
                                        matchResult = 0;
                                        tidx_1 = matchValue_5;
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                                switch (matchResult) {
                                    case 0:
                                        return singleton(tableInfoPanel(item_1(tidx_1, state.Tables), state.ArrangementAssignments, state.Guests));
                                    default:
                                        return singleton(createElement("p", {
                                            className: "text-muted text-sm",
                                            children: t_4(Detail_noSelection),
                                        }));
                                }
                            }
                            else {
                                const matchValue_4 = findGuest(state.Guests, matchValue_3);
                                return (matchValue_4 == null) ? singleton(createElement("p", {
                                    className: "text-muted text-sm",
                                    children: t_4(Detail_noSelection),
                                })) : singleton(guestInfoPanel(matchValue_4, state.ArrangementAssignments, state.Tables, state.Pairs, state.Guests, state.Families));
                            }
                        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : (!state.IsEditMode ? singleton(listView(state)) : singleton(createElement("div", createObj(ofArray([["className", "arrangement-detail-layout"], (elems_2 = toList(delay(() => {
                    let elems;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "arrangement-tables-area"], ["onClick", (_arg) => {
                        if (state.IsEditMode && (state.EditSwapFirst != null)) {
                            dispatch(new Msg(199, []));
                        }
                    }], (elems = toList(delay(() => collect_1((matchValue_2) => singleton(renderTable(matchValue_2[1], matchValue_2[0], state.ArrangementAssignments, state.Guests, familyColorMap, state.SelectedDetailGuestId, state.SelectedDetailTableIndex, state.IsEditMode, state.EditSwapFirst, state.LockedGuestIds, dispatch)), indexed(state.Tables)))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                        let elems_1;
                        return !state.IsEditMode ? singleton(createElement("div", createObj(ofArray([["className", "arrangement-detail-sidebar"], (elems_1 = toList(delay(() => {
                            const matchValue_3 = state.SelectedDetailGuestId;
                            if (matchValue_3 == null) {
                                const matchValue_5 = state.SelectedDetailTableIndex;
                                let matchResult_1, tidx_1;
                                if (matchValue_5 != null) {
                                    if (matchValue_5 < length(state.Tables)) {
                                        matchResult_1 = 0;
                                        tidx_1 = matchValue_5;
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                                switch (matchResult_1) {
                                    case 0:
                                        return singleton(tableInfoPanel(item_1(tidx_1, state.Tables), state.ArrangementAssignments, state.Guests));
                                    default:
                                        return singleton(createElement("p", {
                                            className: "text-muted text-sm",
                                            children: t_4(Detail_noSelection),
                                        }));
                                }
                            }
                            else {
                                const matchValue_4 = findGuest(state.Guests, matchValue_3);
                                return (matchValue_4 == null) ? singleton(createElement("p", {
                                    className: "text-muted text-sm",
                                    children: t_4(Detail_noSelection),
                                })) : singleton(guestInfoPanel(matchValue_4, state.ArrangementAssignments, state.Tables, state.Pairs, state.Guests, state.Families));
                            }
                        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))));
            })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
        }
        else {
            return createElement("div", {
                className: "text-muted",
                children: t_4(Detail_notFound),
            });
        }
    }
    else {
        return createElement("div", {
            className: "text-muted",
            children: t_4(Detail_noArrangement),
        });
    }
}

